import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import { ILocalizedDateFilter } from './LocalizedDateFilter';

Module.instance().filter('localizedLastSignedInDateTime', ['$translate', ($translate: ng.translate.ITranslateService): ILocalizedDateFilter => {
  return (value: any) => {
    if(value){
      return L10n.localizedDateTime(value);
    } else {
      return $translate.instant('never');
    }
  };
}]);
